<template>
  <div class="device_cb_list">
    <div class="width_base" @click="$emit('click')">

      <div v-if="item.switchStatus == 1" class="cb_device_head cb_device_text">
        <i class="iconfont icon-chuanganqishuju"></i>
        <span v-if="item.deviceCbid">{{item.deviceCbid.cbidName}}</span>
        <span v-else>{{item.cbId}}</span>
        <el-button style="float: right; font-size: 16px; color: white;" type="text">
          <span>合闸</span>
        </el-button>
      </div>

      <div v-if="item.switchStatus == 0" class="cb_device_head_offline cb_device_text">
        <i class="iconfont icon-chuanganqishuju"></i>
        <span v-if="item.deviceCbid">{{item.deviceCbid.cbidName}}</span>
        <span v-else>{{item.cbId}}</span>
        <el-button style="float: right; font-size: 16px; color: white;" type="text">
          <span>跳闸</span>
        </el-button>
      </div>

      <div class="flex_cb_device">
        <div class="cb_content">
          <div class="cb_chart"><curr-ring-chart :data="item"></curr-ring-chart></div>
          <div class="cb_content_info">
            <span class="cb_content_title">电流</span>
            <span class="cb_content_value">
              <div class="cb_round_acurr"></div><div class="cb_round_acurr_value" v-if="item.phaseBCurr !== 655.35">A相：</div><div class="cb_content_num" v-if="this.getOnlineStat">{{item.phaseACurr}}</div><div class="cb_content_num" v-else>0</div><div class="cb_round_acurr_value">A</div>
            </span>
            <span class="cb_content_value" v-if="item.phaseBCurr !== 655.35">
              <div class="cb_round_bcurr"></div><div class="cb_round_acurr_value">B相：</div><div class="cb_content_num" v-if="this.getOnlineStat">{{item.phaseBCurr}}</div><div class="cb_content_num" v-else>0</div><div class="cb_round_acurr_value">A</div>
            </span>
            <span class="cb_content_value" v-if="item.phaseBCurr !== 655.35">
              <div class="cb_round_ccurr"></div><div class="cb_round_acurr_value">C相：</div><div class="cb_content_num" v-if="this.getOnlineStat">{{item.phaseCCurr}}</div><div class="cb_content_num" v-else>0</div><div class="cb_round_acurr_value">A</div>
            </span>
          </div>
        </div>

        <div class="cb_content">
          <div class="cb_chart"><volt-ring-chart :data="item"></volt-ring-chart></div>
          <div class="cb_content_info">
            <span class="cb_content_title">电压</span>
            <span class="cb_content_value">
              <div class="cb_round_acurr"></div><div class="cb_round_acurr_value" v-if="item.phaseBVolt !== 655.35">A相：</div><div class="cb_content_num" v-if="this.getOnlineStat">{{item.phaseAVolt}}</div><div class="cb_content_num" v-else>0</div><div class="cb_round_acurr_value">V</div>
            </span>
            <span class="cb_content_value" v-if="item.phaseBVolt !== 655.35">
              <div class="cb_round_bcurr"></div><div class="cb_round_acurr_value">B相：</div><div class="cb_content_num" v-if="this.getOnlineStat">{{item.phaseBVolt}}</div><div class="cb_content_num" v-else>0</div><div class="cb_round_acurr_value">V</div>
            </span>
            <span class="cb_content_value" v-if="item.phaseCVolt !== 655.35">
              <div class="cb_round_ccurr"></div><div class="cb_round_acurr_value">C相：</div><div class="cb_content_num" v-if="this.getOnlineStat">{{item.phaseCVolt}}</div><div class="cb_content_num" v-else>0</div><div class="cb_round_acurr_value">V</div>
            </span>
          </div>
        </div>

        <div class="cb_content">
          <div class="cb_chart"><temp-ring-chart :data="item"></temp-ring-chart></div>
          <div class="cb_content_info">
            <span class="cb_content_title">温度</span>
            <span class="cb_content_value">
              <div class="cb_round_acurr"></div><div class="cb_content_num" v-if="this.getOnlineStat">{{item.temperature}}</div><div class="cb_content_num" v-else>0</div><div class="cb_round_acurr_value">℃</div>
            </span>
          </div>
        </div>

        <div class="cb_content">
          <div class="cb_chart"><leak-ring-chart :data="item"></leak-ring-chart></div>
          <div class="cb_content_info">
            <span class="cb_content_title">漏电</span>
            <span class="cb_content_value">
              <div class="cb_round_acurr"></div><div class="cb_content_num" v-if="this.getOnlineStat">{{item.leakageCurrent}}</div><div class="cb_content_num" v-else>0</div><div class="cb_round_acurr_value">mA</div>
            </span>
          </div>
        </div>
      </div>

      <div class="flex_cb_control">
        <el-button class="buttonPren button01" @click.stop="openDown(air)">预设参数</el-button>
      </div>

    </div>

    <el-dialog class="dialog12" :title=title :visible.sync="dialogFormVisible" width="749px"
               :close-on-click-modal="false">
      <el-form :model="form" label-width="0">
        <el-row>
          <el-col :span="8">
            <div class="flex">
              <div class="flex_icon">
                <span class="iconfont icon-guozaidianliu"></span>
              </div>
              <div class="flex_data">
                <p>过载电流阈值</p>
                <p class="dataDeta">{{form.overloadCurrent}} </p>
              </div>
              <div class="flex_danwei">
                A
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex">
              <div class="flex_icon">
                <span class="iconfont icon-guozaidianliu"></span>
              </div>
              <div class="flex_data">
                <p>过流跳闸时间</p>
                <p class="dataDeta">{{form.overcurrentTime}}</p>
              </div>
              <div class="flex_danwei">
                min
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex none">
              <div class="flex_icon">
                <span class="iconfont icon-wendu1"></span>
              </div>
              <div class="flex_data">
                <p>温度预警值</p>
                <p class="dataDeta">{{form.tempwarningValue}}</p>
              </div>
              <div class="flex_danwei">
                ℃
              </div>
            </div>
          </el-col>

          <el-col :span="8">
            <div class="flex">
              <div class="flex_icon">
                <span class="iconfont icon-guoyaqianya"></span>
              </div>
              <div class="flex_data">
                <p>过压阈值</p>
                <p class="dataDeta">{{form.overloadVoltage}}</p>
              </div>
              <div class="flex_danwei">
                V
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex">
              <div class="flex_icon">
                <span class="iconfont icon-guoyaqianya"></span>
              </div>
              <div class="flex_data">
                <p>欠压阈值</p>
                <p class="dataDeta">{{form.underVoltage}}</p>
              </div>
              <div class="flex_danwei">
                V
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex none">
              <div class="flex_icon">
                <span class="iconfont icon-loudian"></span>
              </div>
              <div class="flex_data">
                <p>漏电阈值</p>
                <p class="dataDeta">{{form.leakageCurrentAlm}}</p>
              </div>
              <div class="flex_danwei">
                mA
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex">
              <div class="flex_icon">
                <span class="iconfont icon-loudianzijian1"></span>
              </div>
              <div class="flex_data">
                <p>漏保功能</p>
                <p class="dataDeta">{{form.leakageFunction ==0? '无' : (form.leakageFunction == 1 ? '有' : '' ) }}</p>
              </div>
              <div></div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex">
              <div class="flex_icon">
                <span class="iconfont icon-shoudongsuoding"></span>
              </div>
              <div class="flex_data">
                <p>锁定手动功能</p>
                <p class="dataDeta">{{form.lockManual == 0? '解除' : (form.lockManual == 0? '能使' : '')}}</p>
              </div>
              <div></div>

            </div>
          </el-col>
          <el-col :span="8">
            <div class="flex none">
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import currRingChart from '@/components/echarts/CurrRingChart'
import voltRingChart from '@/components/echarts/VoltRingChart'
import tempRingChart from '@/components/echarts/TempRingChart'
import leakRingChart from '@/components/echarts/LeakRingChart'
import rightNavigation from '@/components/navigation/RightNavigation'
export default {
  props: ['item'],
  components: {
    currRingChart,
    voltRingChart,
    tempRingChart,
    leakRingChart,
    rightNavigation
  },
  data() {
    return {
      dialogFormVisible: false,
      form: {},
      title: '',
      thisMonth: '',
      lastMonth: '',
      thisYear: '',
      total: '',

    }
  },
  mounted() {
    this.getElectricity()

  },
  computed: {
    getOnlineStat() {
      return this.$store.state.device.onlineStat;
    }
  },
  methods: {
    getElectricity() {
      // console.log(this.air)
      this.$http.post('api/device/eledeg', {
        deviceId: this.item.deviceId,
        deviceType: 2,
        cbId: this.item.cbId,
        bPhaseCurr: this.item.bPhaseCurr,
        cPhaseCurr: this.item.cPhaseCurr
      }).then(res => {
        this.thisMonth = res.current[1].data[0].eledeg.toFixed(1);
        this.lastMonth = res.current[0].data[0] == null ? 0 : res.current[0].data[0].eledeg.toFixed(1);
        this.thisYear = res.current[2].data[0].eledeg.toFixed(1);
        this.total = res.current[3].data[0].eledeg.toFixed(1);
        this.$emit('childValue', res.current[4].data[0].eledeg.toFixed(1));
      })
    },
    openDown(item) {
      this.dialogFormVisible = true;
      this.form = item;
      this.title = (item.cbidName ? item.cbidName : item.cbId) + '线路参数';
    },
    submitForm() {
      this.$http.post('http://wisdom.consec.top:7001/modifyparam', this.form).then(res => {
        this.$message({
          type: 'success',
          message: '线路参数修改成功!'
        });
      });
      this.dialogFormVisible = false;
    }

  }
}
</script>


<style lang="scss">

.record_air_list {
  border-radius: 23px;
  // border: 2px solid #B0B1B3;
  margin-right: 5%;
  //padding: 10px  0 15px 0;
  background: #fff;

  .span_h4 {
    position: relative;

    h4 {
      font-size: 30px;
      height: 85px;
      padding: 0 32px;
      line-height: 85px;
      background: linear-gradient(to right, #35E1B4, #10C9E8);
      color: #fff;
      border-top-left-radius: 23px;
      border-top-right-radius: 23px;
    }

    .total_div {
      position: absolute;
      bottom: 20px;
      right: 6%;
      color: #fff;
      font-size: 16px;
    }
  }

}

.data {
  width: 100%;
  height: 140px;
  float: left;
  border: 1px solid #e5e5e5;
  border-radius: 23px;
  box-sizing: border-box;
  flex-wrap: wrap;

  .el-row {
    .el-col-6,
    .el-col-5 {
      height: 80px;
    }
  }
}

.parameter {
  float: right;
  border: 1px solid #e5e5e5;
  border-radius: 0 20px 20px 0;
  padding: 10px 10px 10px 20px;
  box-sizing: border-box;

  .airData {
    font-size: 12px;
  }

  .txt_par {
    display: inline-block;
    font-size: 12px;
    width: 100px;
  }
}

.txt_icon {
  float: left;
  margin-top: 15px;
}

.shuju_span {
  text-align: left;
  float: left;
  /*margin-top: 7px;*/
}

.shuju {
  margin: -3px 10px 0 0;
  font-size: 22px;
  float: right;
  text-align: right;
}

.danweiBox {
  float: right;
  margin-top: 25px;
}

.bpBox {
  float: right;
  margin-top: 15px;
}

h4 {
  margin-bottom: 5px;
}

.cbid_name {
  display: inline-block;
}

.buttonPren {
  position: absolute;
  bottom: 15px;
  left: 2%;
  border-radius: 10px;
  /*float: right;*/
  height: 30px;
  width: 80px;
  // margin: 8px 0;
  color: #409EFF;
  border: 1px solid #277AFF;
  line-height: 0.5;
  padding: 0;
}

/*.el-input {*/
/*    width: 40%!important;*/
/*    margin: 0 10px 0 40% !important;*/
/*}*/
/*.el-input__inner {*/
/*    text-align: right!important;*/
/*}*/
/*.el-switch {*/
/*    margin: 0 10px 0 40% !important;*/
/*}*/
/*.el-form {*/
/*    margin-left: 50px!important;*/
/*}*/

.none {
  border-right: none !important;
}

.flex {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
  height: 100px;
  padding: 0 10px;

  .flex_icon {
    /*width: 20%;*/
    text-align: center;
    line-height: 100px;

    .iconfont {
      font-size: 45px;
    }
  }

  .flex_danwei {
    /*width: 20%;*/
    text-align: center;
    line-height: 100px;
    font-size: 40px;

  }

  .flex_data {
    padding: 0 5px 0 0;
    /*width: 60%;*/
    margin-top: 25px;
    font-size: 14px;
    color: #ccc;
    text-align: center;

    .dataDeta {
      margin-top: 3px;
      font-size: 25px;
      color: #000;
    }
  }
}

.el-dialog__body {
  margin: -20px;
}

.dianFlex {
  display: flex;
  align-items: center;
  height: 140px;
  border-right: 1px solid #e5e5e5;

  .dian_icon {
    width: 20%;
    text-align: center;
    margin-top: 10px;

    .iconfont {
      font-size: 22px;
      margin-right: 0;
    }
  }

  .loadData {
    width: 55%;

    .left {
      float: left;
      width: 60%;
    }

    .right {
      float: right;
      width: 40%;
    }

    .ben01 {
      font-size: 12px;
      margin-top: 25px;
      color: #B4B4B4;
    }

    .ben02 {
      font-size: 22px;
    }

    .ben03 {
      font-size: 12px;
      margin-top: 15px;
      color: #B4B4B4;
    }
  }

  .danwei {
    font-size: 25px;
    color: #B4B4B4;
    margin-top: 10px;
  }


}

// .button01 {
//     margin: 0px 0 15px;
// }
.button {
  text-align: center;
}

.voltageData {
  padding: 0px !important;
}

// .el-dialog__header{

// }.el-dialog__headerbtn {
//     top: 20px !important;
//     right: 20px !important;
// }
.hr_1 {
  border-bottom: 1px solid #A9A9A9;
  width: 100%;
  margin: 10px auto 15px;
}

.shu_div {
  width: 56.4%;

  .iconfont {
    color: #49D79E;
    margin-right: 5px;
  }

  .p1 {
    position: relative;
    margin-bottom: 5px;
  }
}

.span1 {
  display: inline-block;
  width: 33%;
  text-align: right;
  margin: 15px 0;
  font-size: 14px;
  color: #696974;
}

.span2 {
  display: inline-block;
  width: 31%;
  text-align: right;
  font-size: 16px;
  font-weight: 600;
  color: #696974;
}

.span3 {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  color: #696974;
  width: 48%;
  text-align: right;
}

.span5 {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  color: #696974;
  width: 15%;
  text-align: right;
}

.span4 {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  color: #696974;
  width: 33%;
  text-align: right;
  position: absolute;
  top: -6%;
}

.flex_img {
  display: flex;
  padding: 0 10px 0 20px;

  .flex_cs {
    position: relative;
    width: 36%;

    p {
      font-size: 16px;
      font-weight: 600;
      position: absolute;
      top: 70px;
      right: 43%;
    }
  }

  .switch_img {
    width: 85px;
    height: 85px;
    position: absolute;
    top: -14%;
    border: 5px solid #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    .kongkai_img {
      width: 60px;
      height: 60px;
    }
  }

}

.span_h4 .total_span {
  color: #626277;
}

.now-data .page_air_detail_wrap .record_air_list {
  width: 35%;
  border-radius: 15px;
  overflow: hidden;
}

.span_h4 {
  height: auto;
}

.record_air_list .span_h4 h4 {
  background: #3DD598;
  height: 45px;
  line-height: 18px;
  font-size: 16px;
  color: #2c3e50;
  padding-top: 12px;
  font-weight: normal;
  padding-left: 26px;
  border-radius: 15px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  font-weight: bold;
}

.total_span {
  font-size: 10px;
  color: #81818A;
  position: absolute;
  left: 20px;
  left: 26px;
  top: 33px
}

.record_air_list .span_h4 .total_div b {
  font-weight: normal;
  font-size: 16px;
}

.record_air_list .span_h4 .total_div {
  bottom: 12px;
  right: 10px;
}

.green1 {
  color: white;
  font-weight: 100;
}

.gray1 {
  color: white;
  font-weight: 100;
}

.air_yuan {
  text-align: center;
  border: 2px solid #a1a1a1;
  //padding:10px 40px;
  width: 54px;
  height: 54px;
  border-radius: 27px;
  -moz-border-radius: 27px; /* 老的 Firefox */
}

.air_float {
  width: 120px;
  height: 120px;
  position: relative;
  float: left;

}

.width_base {
  width: 100%;
}

.flex_img {
  display: block;
  margin-top: 30px;
  padding-left: 15px;
}

.air_float_div {
  position: absolute;
  height: 66px;
  width: 66px;
  top: 0;
  left: 0;
}

.air_float_span {
  position: absolute;
  top: 16px;
  display: block;
  text-align: center;
  width: 100%;
  font-size: 18px;
  color: black;
}

.air_float_p {
  position: absolute;
  top: 39px;
  display: block;
  text-align: center;
  width: 100%;
  font-size: 0.5rem;
  color: #96969e;
  transform: scale(0.8)
}

.air_float_img {
  width: 55px;
}

.air_float_span1 {
  color: black;
  position: absolute;
  top: 17px;
  left: 80px;
  font-size: 12px;
}

.air_float_span2 {
  color: #696974;
  position: absolute;
  top: 42px;
  left: 80px;
  font-size: 12px;
}

.air_float_span3 {
  color: #696974;
  position: absolute;
  top: 28px;
  left: 117px;
  font-size: 16px;
}

.flex_img .flex_cs {
  position: inherit;
}

.buttonPren {
  position: inherit;
}

.flex_cs {
  background: #ebeef5;
  margin-top: 30px;
}

.record_air_list {
  overflow: hidden;
}

.buttonPren {
  margin: auto;
  display: block;
  background: none;
  border: none;
}

.buttonPren:hover {
  margin: auto;
  display: block;
  background: none;
  border: none;
}

.air_zhi {
  height: 50px;
  float: left;
  width: 100%;
}

.air_zhi_l {
  float: left;
  width: 50%;
  height: 50px;
  position: relative;
}

.air_zhi_span1 {
  color: #96969e;
  position: absolute;
  top: 6px;
  left: 10px;
  font-size: 12px;
  transform: scale(0.9)
}

.air_zhi_span2 {
  color: black;
  position: absolute;
  top: 8px;
  left: 80px;
  font-size: 12px;
  transform: scale(0.9)
}

.air_zhi_span3 {
  color: #96969e;
  position: absolute;
  top: 25px;
  left: 10px;
  font-size: 12px;
  transform: scale(0.9)
}

.air_zhi_span4 {
  color: black;
  position: absolute;
  top: 23px;
  left: 80px;
  font-size: 12px;
  transform: scale(0.9)
}

.air_zhi_span5 {
  color: #696974;
  position: absolute;
  top: 12px;
  left: 117px;
  font-size: 16px;
}

.now-data .page_air_detail_wrap .selected {
  background: #898db085 !important;
}

.now-data .page_air_detail_wrap .selected .buttonPren {
  background: none !important;
  color: #409EFF !important;
  border: none !important;
}

.now-data .page_air_detail_wrap .buttonPren {
  font-size: 12px !important;
  font-weight: bold !important;
}

//.page_air_detail_wrap .selected[data-v-5f854a45] .span_h4 h4{ background: #FFAB6D!important;}
.record_air_list .span_h4 .hezha {
  background: #3dd598 !important;
}

.record_air_list .span_h4 .tiaozha {
  background: #D6D5D5 !important;
}


.bg {
  width: 66px;
  height: 66px;
  border-radius: 100%;
  background: #EBEAF9;
  position: relative;
  margin: 0px auto;
  overflow: hidden;
  border: solid 0px;
}

.circle-right, .circle-left, .mask-right, .mask-left {
  width: 66px;
  height: 66px;
  border-radius: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

.circle-right, .circle-left {
  background: #4AC299;
}

.bg_red .circle-right, .bg_red .circle-left {

  background: #EA5E5E;

}

.mask-right, .mask-left {

  background: #EBEAF9;
}

.circle-right, .mask-right {
  clip: rect(0, 66px, 66px, 33px);
}

.circle-left, .mask-left {
  clip: rect(0, 33px, 66px, 0);
}

.text0 {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 12px;
  color: deepskyblue;
  border-radius: 100%;
  background: #fff;
  position: absolute;
  top: 3px;
  left: 3px;
}


.bg1 {
  width: 66px;
  height: 66px;
  border-radius: 100%;
  background: #EBEAF9;
  position: relative;
  margin: 0px auto;
  overflow: hidden;
  border: solid 0px;
}

.circle-right1, .circle-left1, .mask-right1, .mask-left1 {
  width: 66px;
  height: 66px;
  border-radius: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

.circle-right1, .circle-left1 {
  background: #4AC299;
}

.bg_red1 .circle-right1, .bg_red1 .circle-left1 {

  background: #EA5E5E;

}

.mask-right1, .mask-left1 {

  background: #EBEAF9;
}

.circle-right1, .mask-right1 {
  clip: rect(0, 66px, 66px, 33px);
}

.circle-left1, .mask-left1 {
  clip: rect(0, 33px, 66px, 0);
}

.text1 {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 12px;
  color: deepskyblue;
  border-radius: 100%;
  background: #fff;
  position: absolute;
  top: 3px;
  left: 3px;
}


.bg2 {
  width: 66px;
  height: 66px;
  border-radius: 100%;
  background: #EBEAF9;
  position: relative;
  margin: 0px auto;
  overflow: hidden;
  border: solid 0px;
}

.circle-right2, .circle-left2, .mask-right2, .mask-left2 {
  width: 66px;
  height: 66px;
  border-radius: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

.circle-right2, .circle-left2 {
  background: #4AC299;
}

.bg_red2 .circle-right2, .bg_red2 .circle-left2 {

  background: #EA5E5E;

}

.mask-right2, .mask-left2 {

  background: #EBEAF9;
}

.circle-right2, .mask-right2 {
  clip: rect(0, 66px, 66px, 33px);
}

.circle-left2, .mask-left2 {
  clip: rect(0, 33px, 66px, 0);
}

.text2 {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 12px;
  color: deepskyblue;
  border-radius: 100%;
  background: #fff;
  position: absolute;
  top: 3px;
  left: 3px;
}

.text6 {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 12px;
  color: deepskyblue;
  border-radius: 100%;
  background: #fff;
  position: absolute;
  top: 1px;
  left: 1px;
}


.bg3 {
  width: 66px;
  height: 66px;
  border-radius: 100%;
  background: #EBEAF9;
  position: relative;
  margin: 0px auto;
  overflow: hidden;
  border: solid 0px;
}

.circle-right3, .circle-left3, .mask-right3, .mask-left3 {
  width: 66px;
  height: 66px;
  border-radius: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
}

.circle-right3, .circle-left3 {
  background: #4AC299;
}

.bg_red3 .circle-right3, .bg_red3 .circle-left3 {

  background: #EA5E5E;

}

.bg_yellow3 .circle-right3, .bg_yellow3 .circle-left3 {

  background: #D69D70;

}

.mask-right3, .mask-left3 {

  background: #EBEAF9;
}

.circle-right3, .mask-right3 {
  clip: rect(0, 66px, 66px, 33px);
}

.circle-left3, .mask-left3 {
  clip: rect(0, 33px, 66px, 0);
}

.text3 {
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 12px;
  color: deepskyblue;
  border-radius: 100%;
  background: #fff;
  position: absolute;
  top: 3px;
  left: 3px;
}

</style>




// WEBPACK FOOTER //
// src/component/base-cb-switch.vue